import { TypeDividerFields } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

// Component
import Divider, { DividerProps } from './Divider'

const ContentfulDivider = withContentful<TypeDividerFields, DividerProps>(Divider)

export default ContentfulDivider
